/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * metapic-api
 * Metapic API
 * OpenAPI spec version: 0.0.1
 */
import * as axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

import type {
  ApproveOrBanUsersRequest,
  ApproveUser200,
  BanUser200,
  CreatorRequest,
  GetUserPerformanceMetricsParams,
  GetUserPerformanceSummaryParams,
  GetuserParams,
  MatchUsers200,
  MatchUsersParams,
  PerformanceMetricsResource,
  UpdateIdentityRequest,
  UpdateUserLocaleRequest,
  UserResource,
  UsersIndex200,
  UsersIndexParams,
} from '../metapicApi.schemas'

export const getUser = (axiosInstance: AxiosInstance = axios.default) => {
  /**
   * Records that the authenticated user requested deletion. This endpoint does not delete the user.
   * @summary Request User Deletion
   */
  const userControllerV2RequestDeletion = (
    user: number,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<void | string>> => {
    return axiosInstance.post(`/v2/users/${user}/deletion-requests`, undefined, options)
  }
  /**
   * Endpoint for querying & sorting all users.
   * @summary List users
   */
  const usersIndex = (
    params?: UsersIndexParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<UsersIndex200>> => {
    return axiosInstance.get(`/v2/users`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * Requires an Ory-issued JWT for a session not yet linked to a Metapic user (no user_id).
   * @summary Create Creator User
   */
  const createUser = (
    creatorRequest: CreatorRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<UserResource>> => {
    return axiosInstance.post(`/v2/users`, creatorRequest, options)
  }
  /**
   * @summary Get User Details
   */
  const getuser = (
    user: number,
    params?: GetuserParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<UserResource>> => {
    return axiosInstance.get(`/v2/users/${user}`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * Returns aggregated performance metrics for the given filters.
   * @summary Get Performance Metrics
   */
  const getUserPerformanceMetrics = (
    params: GetUserPerformanceMetricsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<PerformanceMetricsResource>> => {
    return axiosInstance.get(`/v2/users/performance/metrics`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * Returns aggregated performance metrics for the given filters. Alias of performance/metrics.
   * @summary Get Performance Summary
   */
  const getUserPerformanceSummary = (
    params: GetUserPerformanceSummaryParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<PerformanceMetricsResource>> => {
    return axiosInstance.get(`/v2/users/performance/summary`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
   * It updates user's email and phone and syncs it with Ory identity.
   * @summary Update User Identity
   */
  const updateUserIdentity = (
    user: number,
    updateIdentityRequest: UpdateIdentityRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<UserResource>> => {
    return axiosInstance.put(`/v2/users/${user}/identity`, updateIdentityRequest, options)
  }
  /**
   * @summary Update User Locale
   */
  const updateUserLocale = (
    user: number,
    updateUserLocaleRequest: UpdateUserLocaleRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<UserResource>> => {
    return axiosInstance.put(`/v2/users/${user}/locale`, updateUserLocaleRequest, options)
  }
  /**
   * @summary Match users by IDs and emails
   */
  const matchUsers = (
    params: MatchUsersParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<MatchUsers200>> => {
    return axiosInstance.post(`/v2/match-users`, undefined, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  /**
 * Approves multiple users at once. When approving a banned user, it cleans up the banned_at (suspended_at) property and sets the approved_at (verified_at).
Events are triggered only for users whose status actually changes.
 * @summary Approve users
 */
  const approveUser = (
    approveOrBanUsersRequest: ApproveOrBanUsersRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<ApproveUser200>> => {
    return axiosInstance.post(`/v2/approve-users`, approveOrBanUsersRequest, options)
  }
  /**
 * Bans multiple users at once. The ban action also deletes all user campaigns.
Events are triggered only for users whose status actually changes.
 * @summary Ban users
 */
  const banUser = (
    approveOrBanUsersRequest: ApproveOrBanUsersRequest,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<BanUser200>> => {
    return axiosInstance.post(`/v2/ban-users`, approveOrBanUsersRequest, options)
  }
  return {
    userControllerV2RequestDeletion,
    usersIndex,
    createUser,
    getuser,
    getUserPerformanceMetrics,
    getUserPerformanceSummary,
    updateUserIdentity,
    updateUserLocale,
    matchUsers,
    approveUser,
    banUser,
  }
}
export type UserControllerV2RequestDeletionResult = AxiosResponse<void | string>
export type UsersIndexResult = AxiosResponse<UsersIndex200>
export type CreateUserResult = AxiosResponse<UserResource>
export type GetuserResult = AxiosResponse<UserResource>
export type GetUserPerformanceMetricsResult = AxiosResponse<PerformanceMetricsResource>
export type GetUserPerformanceSummaryResult = AxiosResponse<PerformanceMetricsResource>
export type UpdateUserIdentityResult = AxiosResponse<UserResource>
export type UpdateUserLocaleResult = AxiosResponse<UserResource>
export type MatchUsersResult = AxiosResponse<MatchUsers200>
export type ApproveUserResult = AxiosResponse<ApproveUser200>
export type BanUserResult = AxiosResponse<BanUser200>
